import React, { Component, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import {
  Modal,
  Row,
  Col,
  Container,
  Button,
  Overlay,
  Popover,
} from "react-bootstrap";
import { Input } from "reactstrap";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { addCoins, exportReport } from "./LoanVlpLedgerActions";
import axios from "../../../apis/Api";
import ExcelIcon from "../../../assets/Images/Distributors/excel-icon.png";
import { toast } from "react-toastify";

const LoanVLPLedger = (props) => {
  const [fileSelected, setFileSelected] = useState(null);

  const Download = () => {
    props.exportReport();
  };

  const SaveVlpLedgerDetail = () => {
    props.addCoins(props.LoanVlpLedger);
  };

  const fileValidation = (event) => {
    const image = event.target.files[0];
    if (!image) {
      event.target.value = null;
      return;
    }
    if (!image.name.match(/\.(xlsx|xls)$/)) {
      toast.error("You can only upload file of type (xlsx, xls)");
      event.target.value = null;
      return;
    } else {
      setFileSelected(event.target.files[0]);
    }
  };

  const submitSheet = (data) => {
    if (fileSelected != null) {
      let requestData = {
        DataFile: fileSelected,
      };

      props.addCoins(requestData);
    } else {
      toast.error("Please select sheet");
    }
  };

  return (
    <div>
      <VzPageContainer title="Coin Repayment Scheme">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Coin Repayment Scheme</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row style={{ marginBottom: 30 }}>
          <Col>
            <div className="form-group">
              <div>
                <div>Select Data Sheet File (Only Excel file)</div>
                {fileSelected && (
                  <div>
                    <img
                      style={{ border: "1px solid #ccc" }}
                      alt="not fount"
                      width={"100px"}
                      height={"100px"}
                      src={ExcelIcon}
                    />
                    <br />
                    <button
                      className="btn btn-info"
                      style={{
                        marginLeft: "10px",
                        marginTop: "10px",
                        marginBottom: "20px",
                      }}
                      onClick={() => {
                        // addOrderModalInitialValue.OrderDataFile = null
                        setFileSelected(null);
                      }}
                    >
                      <i className="fa fa-close" />
                      Remove
                    </button>
                  </div>
                )}
                {!fileSelected && (
                  <div>
                    <br />
                    <input
                      type="file"
                      name="setFileSelected"
                      onChange={(event) => fileValidation(event)}
                    />
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col>
            <div className="form-group">
              <Button
                className="form-btn"
                variant="primary"
                style={{
                  marginRight: "10px",
                  marginTop: "10px",
                  float: "right",
                }}
                onClick={submitSheet}
              >
                Execute Operation
              </Button>
              {/* <Button
                className="form-btn"
                variant="outline-primary"
                onClick={Download}
              >
                Export Coin Detail
              </Button> */}
            </div>
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    LoanVlpLedger: state.LoanVlpLedger ? state.LoanVlpLedger : [],
  };
};

export default connect(mapStateToProps, {
  addCoins,
  exportReport,
})(LoanVLPLedger);
